import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: [],
    refresh: false,
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setRefresh: (state, action) => {
            state.refresh = !state.refresh;
        }
    }
})

export default userSlice;
export const userActions = userSlice.actions;